﻿import './scss/app.scss';
import Pristine from 'pristinejs';

const form = document.getElementById('set_password_form');
const formBtn = form.querySelector('button[type="submit"]');
const pristine = new Pristine(form);

const pw = document.getElementById('pw');
const confirm = document.getElementById('pw_repeat');

if (pw)
{
    pw.value = "";
}

confirm?.addEventListener('change', function (e) {
    pw.dispatchEvent(new Event('change'));
});

const pwDontMathMsg = document.getElementById('passwords_dont_match');

var email = form.querySelector('input[name="Email"]');
const EMAIL_REGEX = /^[A-Za-z0-9а-яА-Я\._-]+@([A-Za-z0-9а-яА-Я]{1,2}|[A-Za-z0-9а-яА-Я]((?!(\.\.))[A-Za-z0-9а-яА-Я.-])+[A-Za-z0-9а-яА-Я])\.[A-Za-zа-яА-Я]{2,}$/

pristine.addValidator(email, function (value, el) {

    return !value || EMAIL_REGEX.test(value)
}, "Некорректный e-mail", 2, false);

pristine.addValidator(pw, function (val) {

    if (val === confirm.value) {
        pwDontMathMsg.textContent = '';
        return true;
    }
    pwDontMathMsg.textContent = 'Пароли не совпадают';
    return false;
}, "", 1, true);


['change', 'input'].map(event => {
    form.addEventListener(event, e => {
        const isFormValid = pristine.validate({}, true);
        if (isFormValid) {
            formBtn.removeAttribute('disabled');
        } else {
            formBtn.setAttribute('disabled', true);
        }
    });
});